import { BaseGym } from '../../types/Gym';
import { AccessToken } from '../../types/authentication';

export const fetchGym = async (gymId: string, token?: AccessToken): Promise<BaseGym> => {
  const publicApiDomain = process.env.NEXT_PUBLIC_PUBLIC_API;
  const isDev = process.env.NEXT_PUBLIC_DEV;
  const bearerToken = 'Bearer ' + token;
  const headers = token ? { [isDev ? 'X-Authorization' : 'Authorization']: bearerToken } : {};
  const endpoint = `${publicApiDomain}/gym/${gymId}`;
  const response = await fetch(endpoint, {
    ...(token && { headers }),
  });

  if (response.status !== 200) {
    const { status, statusText } = response;

    const text = await response.text();
    const message = `Status: ${status} Endpoint: ${endpoint} StatusText: ${statusText} Body: ${text}`;
    throw new Error(message);
  }

  try {
    return <BaseGym>await response.json();
  } catch (e) {
    throw new Error('unable to decode json. Response body text: ' + (await response.text()));
  }
};
